export default "__VITE_ASSET__910c8a22__"